import { AttributesState } from 'types/attributes/attributes.types';
import { AttributesActionTypes, GET_ATTRIBUTES_SUCCESS, GET_ATTRIBUTES_FAILURE, GET_ATTRIBUTES_REQUEST } from './attributes.types';

const initialState: AttributesState = {
    attributes: null,
    loading: false,
    error: null,
};

const attributesReducer = (
    state: AttributesState = initialState,
    action: AttributesActionTypes
): AttributesState => {
    switch (action.type) {
        case GET_ATTRIBUTES_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case GET_ATTRIBUTES_SUCCESS:
            return {
                ...state,
                loading: false,
                attributes: action.payload,
                error: null
            };
        case GET_ATTRIBUTES_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
};

export default attributesReducer; 